export const UPDATE_EMAIL_PHONE = 'update_email_phone';
export const RESET_PASSWORD = 'reset_password';
export const CHANGE_LOGIN_TYPE = 'change_login_type';
export const COMPLETE_USER_SIGN_UP = 'complete_user_sign_up';

export const roleNames = {
  handyman: 'handyman',
  superintendent: 'superintendent',
  property_manager: 'property_manager',
  tenant: 'tenant',
  owner: 'owner',
  visitor: 'visitor',
  board_member: 'board_member',
  pmc_owner: 'pmc_owner',
  broker: 'broker',
  prospective_tenant: 'prospective_tenant',
  concierge: 'concierge',
};
